import CloseIcon from '@mui/icons-material/Close'
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  Grid,
  IconButton,
  Typography,
} from '@mui/material'
import { formatDate } from '../../../../app/utils'
import { useIntl } from 'react-intl'
import Documents from '../../../Documents/Documents'
import { messages } from './messages'
import DefaultSpacingGrid from '../../../../components/Containers/DefaultSpacingGrid'

interface DocumentModalProps {
  tenantId: number
  customerId: number
  open: boolean
  onClose: () => void
  rowData: any
  documentType?: 'PRICE' | 'CURRENCY'
  isViewMode?: boolean
  priceIndex: number
}

const DocumentModal = ({
  tenantId,
  customerId,
  open,
  onClose,
  rowData,
  priceIndex,
  documentType = 'PRICE',
  isViewMode = false,
}: DocumentModalProps) => {
  const { formatMessage } = useIntl()
  const modalTitle = `${formatMessage(messages.viewDocument)} - ${documentType} (${rowData.currency
    })`

  const formatDateDisplay = (date: string) => {
    if (!date || date === '∞') return date
    return formatDate(date)
  }

  const getMetadataFields = () => {
    const commonFields = [
      {
        label: formatMessage(messages.currency),
        value: rowData.currency,
      },
      {
        label: formatMessage(messages.validFrom),
        value: formatDateDisplay(rowData.validFrom),
      },
      {
        label: formatMessage(messages.validTo),
        value: rowData.validTo,
      },
    ]

    if (documentType === 'PRICE') {
      return [
        ...commonFields,
        {
          label: formatMessage(messages.activePrice),
          value: rowData.price,
        },
        {
          label: formatMessage(messages.description),
          value: rowData.description || '-',
        },
      ]
    } else {
      return [
        ...commonFields,
        {
          label: formatMessage(messages.activePrice),
          value: rowData.price,
        },
        {
          label: formatMessage(messages.daysInUse),
          value: rowData.daysInUse,
        },
      ]
    }
  }

  const renderMetadataSection = () => (
    <Box sx={{ mb: 4 }}>
      <DefaultSpacingGrid container spacing={3}>
        {getMetadataFields().map((field, index) => (
          <Grid item xs={6} key={index}>
            <Box>
              <Typography variant='body2' color='textSecondary' mb={1}>
                {field.label}
              </Typography>
              <Typography variant='body1' fontWeight='medium'>
                {field.value}
              </Typography>
            </Box>
          </Grid>
        ))}
      </DefaultSpacingGrid>
    </Box>
  )

  return (
    <Dialog open={open} onClose={onClose} maxWidth='md' fullWidth>
      <DialogTitle>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <Typography variant='h6'>{modalTitle}</Typography>
          <IconButton onClick={onClose} size='small'>
            <CloseIcon />
          </IconButton>
        </Box>
      </DialogTitle>
      <Divider />
      <DialogContent>
        {renderMetadataSection()}
        <Box sx={{ mt: 2 }}>
          <Documents
            categoryId={4}
            entityId={rowData.id}
            entityType={documentType}
            isDisabled={isViewMode}
            tenantId={tenantId}
            customerId={customerId}
            rowId={priceIndex}
          />
        </Box>
      </DialogContent>
      <DialogActions>
        <Button variant='contained' onClick={onClose}>
          {formatMessage(messages.closeCaps)}
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default DocumentModal
